import { Component, Vue } from "vue-property-decorator";
import { Categories } from "@/helpers/constants";
import { Category } from "@/services/apiService/api.types";
import apiStorageInterface, {
  sortedCategories
} from "@/services/apiStorageInterface";

@Component
export class ChannelCategoriesFilter extends Vue {
  //@TODO implement mixin everywhere it is needed
  categories: Record<Categories, Category> = sortedCategories;
  filteredCategories: Categories[] = [];

  async setCategories(): Promise<void> {
    this.categories = await apiStorageInterface.fetchSortedCategories();
  }
  //filters out categories with no channels
  async filteredCategoriesFunc(): Promise<void> {
    if (this.categories) {
      this.categories[Categories.AllChannels].channels =
        await apiStorageInterface.fetchCustomChannelList();
      Object.entries(this.categories).forEach(([key, value]) => {
        if (value.channels && value.channels.length > 0) {
          if (!this.filteredCategories.includes(key as Categories)) {
            this.filteredCategories.push(key as Categories);
          }
        }
      });
    }
    this.filteredCategories.sort((a, b) => a.localeCompare(b));

    const allChannelsIndex = this.filteredCategories.findIndex(
      (category) => category === Categories.AllChannels
    );

    const favoritesIndex = this.filteredCategories.findIndex(
      (category) => category === Categories.Favorites
    );

    //remove initial positioning of all channels category
    this.filteredCategories.splice(allChannelsIndex, 1);

    //setting all channels as first item
    this.filteredCategories.splice(0, 0, Categories.AllChannels);

    //setting required category order
    if (this.filteredCategories.includes(Categories.Favorites)) {
      //remove initial positioning of all channels category
      this.filteredCategories.splice(favoritesIndex, 1);

      this.filteredCategories.splice(1, 0, Categories.Favorites);
    }
  }
}
